export default ({...props}) => {
  return `
      @media screen and (max-width: 720px) {
        display: none;
      }
    `
}

export const pageContentStyles = ({...props}) => {
  return `
    @media screen and (min-width: 720px) {
      display: none;
    }
  `
}

export const modalBoxStyles = ({...props}) => {
  const {palette, size} = props.theme
  return `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: ${size(2.5)}px;
    background-color: ${palette.common.white};
  `
}
